import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';

@Component({
  selector: 'app-tm-popup-entry',
  templateUrl: './tm-popup-entry.component.html',
  styleUrls: ['./tm-popup-entry.component.scss']
})
export class TmPopupEntryComponent implements OnInit {

  label = 'Title';
  titleForm: UntypedFormGroup = new UntypedFormGroup({
    title: new UntypedFormControl(null),
    id: new UntypedFormControl(null),
    index: new UntypedFormControl(null)
  })
  options = [];
  id_property = 'id';
  title_property = 'title';
  constructor(
    private dialog_ref: MatDialogRef<TmPopupEntryComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit(): void {
    if (this.data) {
      this.id_property = this.data.id_property;
      this.title_property = this.data.title_property;
      this.options = this.data.options;
      this.label = this.data.label;
    }
  }

  close() {
    this.dialog_ref.close()
  }

  save() {
    if (this.options && this.options.length) {
      let index = this.options.findIndex(data => this.titleForm.value.title == data[this.title_property]);
      this.titleForm.controls.index.patchValue(index)
      if (index > -1) {
        this.titleForm.controls.id.patchValue(this.options[index][this.id_property]);
      }
      else {
        this.titleForm.controls.id.patchValue(0);
      }
      this.dialog_ref.close(this.titleForm.value);
    }
    else {
      this.dialog_ref.close(this.titleForm.value);
    }
  }
}
